<template>
    <div id="main-container" class="container-md px-0 px-md-5">
        <div class="navbar-container">
            <slot name="navbar"></slot>
        </div>
        <div class="scrollable-container" style="background-color: white;">
            <CContainer md class="px-0">
                <div :class="padding ? 'p-3' : ''">
                    <slot></slot>
                </div>
            </CContainer>
        </div>
        <div class="fixed-container">
            <CContainer md class="px-0" style="align-items: center;">
                <BottomBar :page="this.page" :loading="this.loading" v-if="this.page != 0" />
                <slot name="bottom-bar"></slot>
            </CContainer>
        </div>
    </div>
</template>

<script>
import { CContainer } from '@coreui/bootstrap-vue';
import BottomBar from './BottomBar.vue';

export default {
    name: 'ContainerLayout',
    data() {
        return {
            //
        };
    },
    props: {
        page: {
            type: String,
            required: true
        },
        loading: {
            type: Boolean,
            default: false,
        },
        customBottomBar: {
            type: Boolean,
            default: false
        },
        padding: {
            type: Boolean,
            default: true
        }
    },
    components: {
        CContainer,
        BottomBar
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.resizePage();
        })
    },
    beforeUnmount() {
        window.removeEventListener('resize', () => {
            this.resizePage();
        })
    },
    methods: {
        resizePage() {
            if (document.getElementById('main-container')) {
                let deviceWidth = window.matchMedia("(max-width: 1024px)");
                if (deviceWidth.matches) {
                    document.getElementById('main-container').style.height = window.innerHeight + 'px';
                } else {
                    document.getElementById('main-container').style.height = '100vh';
                }

                if (document.getElementsByClassName('navbar-container')[0] && document.getElementsByClassName('fixed-container')[0] && document.getElementsByClassName('scrollable-container')[0]) {
                    let mainContainerHeight = document.getElementById('main-container').offsetHeight;
                    let navbarContainerHeight = document.getElementsByClassName('navbar-container')[0].offsetHeight;
                    let fixedContainerHeight = document.getElementsByClassName('fixed-container')[0].offsetHeight;

                    document.getElementsByClassName('scrollable-container')[0].style.height = (mainContainerHeight - navbarContainerHeight - fixedContainerHeight) + 'px';
                }
            }
        }
    }
};
</script>